import validate from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45to_45uk_45global from "/opt/atlassian/pipelines/agent/build/middleware/redirect-to-uk.global.ts";
import startpage_45global from "/opt/atlassian/pipelines/agent/build/middleware/startpage.global.ts";
import manifest_45route_45rule from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45to_45uk_45global,
  startpage_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}